import React from "react";
import { Box } from "@mui/material";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { ContainerHeader } from "src/components-mui/layout/container";
import { HeroSliderNav } from "src/components-mui/modules/hero-module/components/hero-slider-nav";
import { HeroSliderSlide, IHeroSliderSlideProps } from "src/components-mui/modules/hero-module/components/hero-slider-slide";
import { getEmblaDelays } from "src/components-mui/modules/hero-module/utils/embla-delay";
import { CONTAINER_HEADER_CLASS } from "./constants";

export interface IHeroSliderModuleProps {
    slides: IHeroSliderSlideProps[];
}

export const HeroSliderModule = ({ slides }: IHeroSliderModuleProps) => {
    const getDelay = (scrollSnaps: number[]): number[] => {
        return getEmblaDelays(scrollSnaps, slides);
    };

    const autoplayInstance = React.useRef(Autoplay({ delay: getDelay }));

    const [emblaRef, embla] = useEmblaCarousel(
        {
            loop: true,
            watchDrag: false,
        },
        [autoplayInstance.current]
    );

    const enableSliderFeatures = slides.length > 1;

    const pauseAutoplay = React.useCallback(() => {
        if (enableSliderFeatures && autoplayInstance.current.isPlaying()) {
            autoplayInstance.current.stop();
        }
    }, [enableSliderFeatures]);

    const resumeAutoplay = React.useCallback(
        (event: React.MouseEvent) => {
            const isContainerHeader = event.target instanceof HTMLElement && event.target.classList.contains(CONTAINER_HEADER_CLASS);

            if (isContainerHeader && enableSliderFeatures) {
                autoplayInstance.current.play();
            }
        },
        [enableSliderFeatures]
    );

    if (slides.length === 0) {
        return null;
    }

    return (
        <ContainerHeader
            position="relative"
            height={["720px", "720px", "650px", "760px"]}
            onMouseEnter={pauseAutoplay}
            onMouseMove={pauseAutoplay}
            onMouseLeave={resumeAutoplay}
        >
            <Box ref={enableSliderFeatures ? emblaRef : undefined} overflow="hidden" width="100%" height="100%">
                <Box display="flex" width="100%" height="100%">
                    {slides.map((slide, i) => (
                        <HeroSliderSlide key={i} {...slide} />
                    ))}
                </Box>
            </Box>
            {enableSliderFeatures && embla ? <HeroSliderNav embla={embla} autoplayInstance={autoplayInstance.current} /> : null}
        </ContainerHeader>
    );
};
